import React, { useEffect, useState } from 'react';
import {HeroWrapper} from './style';
import { useRouter } from 'next/router';
import lodashDebounce from 'lodash.debounce';
import { useDispatch } from 'react-redux';

// Component
import Container from 'components/common/Layout/Container';
import SearchInput from 'components/common/SearchInput';
import Button from 'components/common/Button';
import Link from 'components/common/Link';
import Text from 'components/common/Text';
import Select from 'components/common/Select'

// Libs && configs
import Translation from 'libs/Translation';

// Actions
import {getAPI} from 'redux/core/actions';

const Hero = ({ webConfig, specialties, cities }) => {
    const router = useRouter();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState();
    const [finalValue, setFinalValue] = useState({});
    const [finalSpecialties, setFinalSpecialties] = useState([{Title: Translation.t('label.all-specialties'), Slug: 'all'}, ...specialties])
    const [finalCities, setFinalCities] = useState([{Title: Translation.t('label.all-cities'), Slug: 'IR'}, ...cities])

    // Set default Value
    useEffect(() => {
        setFinalValue({city: {Title: Translation.t('label.all-cities'), Slug: 'IR'}, specialty: {Title: Translation.t('label.all-specialties'), Slug: 'all'}})
    }, [])

    const handleChange = e => {
        const {value, name} = e.target;
        const newValue = {[name]: value};
        const filteringValue = {...finalValue, ...newValue};
        setFinalValue(filteringValue);
    }

    const handleSelect = (name, label, value) => {
        const newValue = {[name]: {Title: label, Slug: value}};
        const filteringValue = {...finalValue, ...newValue};
        setFinalValue(filteringValue);
    }

    const handlePushToRoute = () => {
        setLoading(true);

        let queries = '';
        if (finalValue.name) {
            queries = `${queries}name=${finalValue.name}&`
        }
        if (webConfig.lang !== 'fa') {
            queries = `${queries}lang=${webConfig.lang}`
        }
       
        router.push(`/explore/doctors/all/${finalValue.specialty.Slug}/city/${finalValue.city.Slug}?${queries}`)
    }

    const handleSearch = (e) => {
            const {value, name} = e.target;

            const newValue = {[name]: value};
            const filteringValue = {...finalValue, ...newValue};
            setFinalValue(filteringValue);

            if (name === 'citySearch') {
                if (value) {
                    dispatch(getAPI('getCities', {search: value}, 'nestApi'))
                        .then(res => {
                            setFinalCities(res);
                        })
                        .catch(err => {
                            console.error(err)
                        })
                }
                else {
                    setFinalCities([{Title: Translation.t('label.all-cities'), Slug: 'IR'}, ...cities]);
                }
            }
            else if (name === 'specialtySearch') {
                if (value) {
                    dispatch(getAPI('getSpecialties', {SpecialtyType: 'SPECIALTY', search: value, lang: webConfig.lang}, 'nestApi'))
                        .then(res => {
                            setFinalSpecialties(res);
                        })
                        .catch(err => {
                            console.error(err)
                        })
                }
                else {
                    setFinalSpecialties([{Title: Translation.t('label.all-specialties'), Slug: 'all'}, ...specialties]);
                }
            }
    }
        
    const debouncedHandleSearch = lodashDebounce((e) => {handleSearch(e)}, 1000)

    return (
        <HeroWrapper webConfig={webConfig}>
            <Container>
                <div
                    className='hero'
                >
                    <div 
                        className='column-flex'
                    >
                        <span
                            className='search-title'
                        >
                            {Translation.t('title.looking-for-doctor')}
                        </span>
                        <div
                            className='search-box'
                        >
                            <SearchInput
                                name='name'
                                handleChange={handleChange}
                                defaultValue={finalValue.name}
                                value={finalValue.name}
                                placeholder={Translation.t('label.doctor-name')}
                                mr="0"
                                handleSearch={handlePushToRoute}
                            />
                            <Select 
                                list={finalCities}
                                value={finalValue.city?.Title}
                                handleSelect={handleSelect}
                                name="city"
                                valueKey='Slug'
                                labelKey='Title'
                                labelKeyByLang="Slug"
                                searchKey="citySearch"
                                searchValue={finalValue.citySearch}
                                handleChange={debouncedHandleSearch}
                                searchBox
                            />
                            <Select 
                                list={finalSpecialties}
                                value={finalValue.specialty?.Title}
                                handleSelect={handleSelect}
                                name="specialty"
                                valueKey='Slug'
                                labelKey='Title'
                                searchKey="specialtySearch"
                                searchValue={finalValue.specialtySearch}
                                handleChange={debouncedHandleSearch}
                                searchBox
                            />
                            <Button
                                className="search-button"
                                onClick={handlePushToRoute}
                                type="submit"
                                loading={loading}
                                disabled={loading}
                            >
                                {Translation.t('label.search')}
                            </Button>
                        </div>
                    </div>
                    <div
                        className='demo-req row-flex'
                    >
                        <Text
                            className="demo-desc"
                            tag="p"
                        >
                            {Translation.t('text.home-demo-desc')}
                        </Text>
                        <Link
                            className="demo-button"
                            to="/register"
                            params={webConfig.lang !== 'fa' ? {lang: webConfig.lang} : {}}
                        >
                            {Translation.t('label.home-demo-button')}
                        </Link>
                    </div>
                </div>
            </Container>
        </HeroWrapper>
    )
}

export default Hero;